import PropTypes from 'prop-types';
import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import ChecksListView from './checksListView';
import GenerateChecksView from './generateChecksView';
import useChecksSettings from './useChecksSettings';

// Checks Settings Modal component
const ChecksSettingsModal = ({
  isOpen,
  onClose,
  checksCollection: _checksCollection = {},
  defaultChecks: _defaultChecks = {},
  path,
  formActions,
  reduxEntity,
  content: _content = null,
  notificationActions,
  pendingOperation: _pendingOperation = false
}) => {
  const {
    currentView,
    checksArray,
    userRequest,
    setUserRequest,
    isGenerating,
    suggestions,
    addingId,
    handleToggle,
    handleDelete,
    handleGenerateClick,
    handleAddSuggestion,
    handleClose,
    handleNavigateToGenerate,
    handleNavigateToList
  } = useChecksSettings({
    checksCollection: _checksCollection,
    defaultChecks: _defaultChecks,
    path,
    formActions,
    reduxEntity,
    content: _content,
    notificationActions,
    pendingOperation: _pendingOperation,
    onClose
  });
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpen,
    toggle: handleClose,
    size: "lg"
  }, currentView === 'list' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ModalHeader, {
    toggle: handleClose
  }, "Quality Agent Settings"), /*#__PURE__*/React.createElement(ChecksListView, {
    checksArray: checksArray,
    onToggle: handleToggle,
    onDelete: handleDelete,
    onGenerateClick: handleNavigateToGenerate,
    onClose: handleClose
  })) : /*#__PURE__*/React.createElement(GenerateChecksView, {
    userRequest: userRequest,
    onUserRequestChange: setUserRequest,
    isGenerating: isGenerating,
    suggestions: suggestions,
    addingId: addingId,
    onGenerate: handleGenerateClick,
    onAddSuggestion: handleAddSuggestion,
    onBack: handleNavigateToList,
    pendingOperation: _pendingOperation
  }));
};
ChecksSettingsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  checksCollection: PropTypes.shape({}),
  defaultChecks: PropTypes.shape({}),
  path: PropTypes.string.isRequired,
  formActions: PropTypes.shape({
    change: PropTypes.func.isRequired,
    handleActions: PropTypes.func
  }).isRequired,
  reduxEntity: PropTypes.string.isRequired,
  content: PropTypes.shape({
    title: PropTypes.string,
    formType: PropTypes.shape({
      name: PropTypes.string
    })
  }),
  notificationActions: PropTypes.shape({
    info: PropTypes.func.isRequired
  }).isRequired,
  pendingOperation: PropTypes.bool
};
export default ChecksSettingsModal;